import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import { parseErrorArrayAndThrowMsg } from './utils';

const DataApiUrl = dataApiUrl();

const ReportInvoices = () => {
  const getAll = params =>
    AuthAxios.get(`${DataApiUrl}/admin/reportInvoices`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getById = id =>
    AuthAxios.get(`${DataApiUrl}/admin/reportInvoices/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const add = (dsp_name, native_currency_abbv) =>
    AuthAxios.post(`${DataApiUrl}/admin/reportInvoices`, {
      dsp_name,
      native_currency_abbv,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patch = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/reportInvoices/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patchNotes = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/reportInvoices/${id}/notes`, data)
      .then(res => res.data.data)
      .catch(parseErrorArrayAndThrowMsg('patch report notesinvoice'));

  const approve = id =>
    AuthAxios.post(`${DataApiUrl}/admin/reportInvoices/${id}/approve`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const adoptMatches = (id, report_currency_ids) =>
    AuthAxios.patch(`${DataApiUrl}/admin/reportInvoices/${id}/adoptReportCurrencies`, {
      report_currency_ids,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const exportInvoiceCsv = id =>
    AuthAxios.get(`${DataApiUrl}/admin/reportInvoices/${id}/export`)
      .then(res => {
        window.confirm(`Statement email will be sent to ${res.data.data.job.data.recipientEmail}`);
      })
      .catch(err => {
        throw err.response;
      });

  return {
    getAll,
    getById,
    add,
    patch,
    patchNotes,
    approve,
    adoptMatches,
    exportInvoiceCsv,
  };
};

export default ReportInvoices;
